export default {
  lang: {
    selectAll: '全選択当ページ',
    selected: '選択済',
    term: '条',
    deselect: '選択をキャンセルします',
  },
};
